<template>
  <div class="sidebar" :style="{ left: leftDistance }">
    <ul>
      <li @click="jump('policy')">法律<br />法规</li>
      <li @click="jump('standard')">标准<br />规范</li>
      <li @click="jump('Opinion')">系统<br />建议</li>
      <!-- <li @click="jump('policy')">法律<br />法规</li> -->
      <!-- <li @click="jump('notice')">系统<br />通知</li> -->
      <li @click="$emit('back-top')">返回<br />顶部</li>

      <li v-if="false" @click="Cvisible">移动<br />应用</li>
    </ul>
    <!-- <my-dialog
      title="申请人客户端下载"
      :visible.sync="dialogVisible"
      center
      width="240px"
      :append-to-body="true"
    >
      <div class="ImgCenter">
        <div>
          <img src="/static/img/side-bar/download_code.png" alt="" />
        </div>
      </div>
    </my-dialog> -->
  </div>
</template>

<script>
// import MyDialog from "@/components/commons/MyDialog";
export default {
  components: {
    // MyDialog
  },
  name: "Sidebar",
  data() {
    return {
      scrolled: 0,
      dialogVisible: false,
    };
  },
  computed: {
    leftDistance() {
      return (document.documentElement.clientWidth - 1150) / 2 + 1153 + "px";
    },
  },
  mounted() {},
  methods: {
    jump(address) {
      let routeData = this.$router.resolve({
        name: address,
        query: address,
        params: {},
      });
      window.open(routeData.href, "_blank");
    },
    Cvisible() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.ImgCenter {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  p {
    text-align: center;
  }
}
.popovers .el-popover {
  height: 148px !important;
}
.sidebar {
  position: fixed;
  top: calc(50vh - 160px);
  z-index: 201;

  ul {
    border: 1px solid #c9c9c9;
    border-radius: 5px;
    overflow: hidden;
    list-style: none;
    padding-left: 0;
    li {
      width: 50px;
      padding: 6px 0;
      border-bottom: 1px solid #c9c9c9;
      background-color: #fff;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      color: #666;
      line-height: 1.4;

      &:last-child {
        border-bottom: none;
      }
    }

    li:hover {
      background-color: #b71c1c;
      color: #fff;
    }
  }
}
/deep/.el-dialog__header {
  padding-top: 15px;
}
/deep/ .el-dialog__body {
  padding: 5px 20px 20px 20px;
}
</style>
